module.exports = __webpack_public_path__ + "img/bottom.ea1ab2b4.svg";